<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-06 16:33:00
 * @FilePath: \gcp-fe\src\app\shop\views\viewNoticeSimpleDetail.vue
 * @Description: 
-->
<template>
  <div class="wrapper">
    <div style="display: flex; align-items: center;">
      <!-- <el-button
        v-if="$route.query.isJRZL === '1'"
        style="margin-right: 10px;"
        type="primary"
        icon="icon-ccui-return"
        @click="back"
        >返回</el-button
      > -->
      <!-- <el-divider
        v-if="$route.query.isJRZL === '1'"
        direction="vertical"
      ></el-divider> -->
      <base-bread-crumb :currBreadCrumb="currBreadCrumb" :isShowPortal="false"></base-bread-crumb>
    </div>
    <div class="ccui-notice-app-container-detail">
      <div class="ccui-notice-app-container-detail-body clearfix">
        <div class="ccui-notice-app-container-detail-left">
          <div class="notice-title">{{ schemeObj.schemeName }}</div>
          <div class="notice-project-info">
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.projectCode") }}：</span>{{ schemeObj.schemeCode }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishTime") }}：</span>{{ schemeObj.noticeStartTime }}
            </div>
            <div class="notice-project-info-li" v-if="
              $route.query.type != 7 &&
              $route.query.type != 8 &&
              $route.query.type != 3 &&
              $route.query.type != 4
            ">
              <span>{{ $t("page.content.publishUnit") }}：</span>{{ schemeObj.opUnitName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="template-notice-detail-body ccui-clearfix">
      <div class="template-notice-detail-full">
        <div class="notice-detail-title">{{ noticeTypeName }}</div>
        <div class="notice-detail-ul clearfix">
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title">{{ $t("page.content.noticeTitle") }}：</span>
            <div class="notice-detail-li-con">{{ pageData.noticeTitle }}</div>
          </div>
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title">{{ $t("page.content.noticeContent") }}：</span>
            <div class="notice-detail-li-con rich-text" v-html="pageData.textInfo"></div>
          </div>
        </div>
        <div class="notice-detail-title" style="padding-top: 40px;">
          {{ $t("page.content.fileList") }}
        </div>
        <detailTable class="dic-sub-table-style01" :tableData="pageData.fileinfoBOS" :tableHead="fileHead"
          :showIndex="true"></detailTable>

        <div class="notice-detail-title" style="padding-top: 40px;">
          {{ $t("page.content.relatedNoticeList") }}
        </div>
        <detailTable :tableData="relateNoticeList" :tableHead="noticeHead" :showIndex="true">
          <template slot="noticeTitle" slot-scope="{ row }">
            <el-button size="mini" type="text" @click="handleNoticeTitle(row)">
              {{ row.noticeTitle }}
            </el-button>
          </template>
        </detailTable>
      </div>
    </div>
    <shareQRCode :code="code"></shareQRCode>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import detailTable from "@/app/shop/components/detail-table";
import { commonTableWidth } from "@/setting/setting";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import shareQRCode from "@/app/shop/components/shareQRCode.vue";
import axios from "axios";
import {
  qryNoticeDetail,
  qryRelatedNoticeList
} from "@/app/shop/api/shoppingSP";
// import $t from "@/app/shop/utils/translateUtil";
export default {
  name: "viewNoticeSimpleDetail",
  components: {
    baseBreadCrumb,
    detailTable,
    shareQRCode
  },
  mixins: [mixinHomePage],
  data() {
    return {
      currBreadCrumb: [{ title: "采购公告", path: "/procurementNotice" }],
      fileHead: [
        { label: this.$t("page.content.fileName"), prop: "fileName" },
        { label: this.$t("page.content.fileDesc"), prop: "fileSumm" },
        {
          label: this.$t("page.content.operation"),
          slot: "opp",
          align: "center",
          width: 100
        }
      ],
      noticeHead: [
        {
          label: this.$t("page.content.type"),
          prop: "noticeTypeName",
          width: 150
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          slot: "noticeTitle"
        },
        {
          label: this.$t("page.content.link"),
          prop: "purStepName",
          width: 150
        },
        {
          label: this.$t("page.content.publishTime"),
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      // packageList: [],
      matDetailList: [],
      pageData: {},
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        opUnitName: this.$route.query.opUnitName, //发布单位
        schemeName: this.$route.query.schemeName, //项目名称
        schemeCode: this.$route.query.schemeCode //项目编号
      },
      noticeTypeName: "",
      type: this.$route.query.type,
      code: ""
    };
  },
  activated() {
    switch (this.type) {
      case "1": //公开采购公告
        this.currBreadCrumb.push({
          title: "公开采购公告",
          path: "/procurementNotice?type=1&source=1"
        });
        break;
      case "2": //邀请采购公告
        this.currBreadCrumb.push({
          title: "邀请采购公告",
          path: "/procurementNotice?type=2&source=1"
        });
        break;
      case "3": //评标结果
        this.currBreadCrumb.push({
          title: "评标/评审结果公示",
          path: "/procurementNotice?type=3&source=1"
        });
        break;
      case "4": //中标结果公示
        this.currBreadCrumb.push({
          title: "中标结果公示",
          path: "/procurementNotice?type=4&source=1"
        });
        break;
      case "5": //中标通知
        this.currBreadCrumb.push({
          title: "中标通知",
          path: "/procurementNotice?type=5&source=1"
        });
        break;
      case "6": //补遗公告
        this.currBreadCrumb.push({
          title: "补遗公告",
          path: "/procurementNotice?type=6&source=1"
        });
        break;
      case "7": //流标公告
        this.currBreadCrumb.push({
          title: "流标公告",
          path: "/procurementNotice?type=7&source=1"
        });
        break;
      case "9": //商城式订单采购公告
        this.currBreadCrumb = [{ title: "商城式订单采购公告" }];
        break;
    }
    this.init();
    // this.setBreadCrumb();
  },
  deactivated() {
    this.currBreadCrumb = [{ title: "采购公告", path: "/procurementNotice" }];
  },
  methods: {
    // $t, // 移植代码存在国际化方案临时解决
    init() {
      switch (this.type) {
        case "3":
          this.noticeTypeName = this.$t("page.content.labelMenu1");
          break;
        case "4":
          this.noticeTypeName = this.$t("page.content.labelMenu5");
          break;
        case "7":
          this.noticeTypeName = this.$t("page.content.labelMenu3");
          break;
        case "8":
          this.noticeTypeName = this.$t("page.content.labelMenu2");
          break;
      }
      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId,
        // purStep: 1,
        qryFileFlag: true
      }).then(res => {
        if (res.data.code === "0" && res.data.data) {
          this.pageData = res.data.data;
          this.$set(
            this.noticeHead[2],
            "isHidden",
            this.pageData.purStep !== "1"
          );
          this.currBreadCrumb.push({
            title: this.pageData.noticeTitle
          });
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
        }
      });

      //查询相关公告列表
      qryRelatedNoticeList({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId
      }).then(res => {
        if (res.data.code === "0") {
          this.relateNoticeList = res.data.data;
        }
      });
      // 如果URL中有noticeId参数，则调用分享二维码接口
      if (this.$route.query.noticeId) {
        this.shareQRCodeRequest();
      }
    },
    shareQRCodeRequest() {
      const apiUrl =
        "https://aimarket.iccec.cn/api-v2/tender-api/info-qr/share";
      const params = {
        scene: this.$route.query.noticeId,
        path: "pages/home/detail"
      };
      axios
        .post(apiUrl, params)
        .then(response => {
          if (response.data.code === 0) {
            this.code = response.data.data;
          }
        })
        .catch(error => {
          console.error("分享二维码请求失败:", error);
        });
    },
    back() {
      const serchTypeMap = {
        首页: "",
        采购公告: "procurementNotice"
      };
      const searchType = this.$route.query.searchType;
      location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${serchTypeMap[searchType]
        }`;
    }
    // setBreadCrumb() {
    //   const handlerClick = searchType => {
    //     const serchTypeMap = {
    //       首页: "",
    //       采购公告: "procurementNotice"
    //     };
    //     location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${
    //       serchTypeMap[searchType]
    //     }`;
    //   };
    //   const source = this.$route.query.searchType;
    //   if (this.$route.query.isJRZL === "1") {
    //     this.currBreadCrumb = [];
    //     this.currBreadCrumb.push({
    //       title: source,
    //       clickFn: this.$route.query.isJRZL === "1" ? handlerClick : null,
    //       to: "/"
    //     });
    //   }
    // }
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
}

/deep/ .template-detail-body .detail-box {
  margin-top: 20px;
  margin-bottom: 0;
}
</style>
